import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class DeviceWideTaskResultAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'deviceWideTaskResult';
	
	getIps(scanid) {
		let request = {
			url: [this.getAPIUrl(), 'scan', scanid, 'ips'].join('/'),
		};

		return httpClient.getAsync(request);
	}
	getPorts(scanid) {
		let request = {
			url: [this.getAPIUrl(), 'scan', scanid, 'ports'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new DeviceWideTaskResultAPI();
